import axios from "@/lib/request";
// 获取产品列表
export const getProductList = (params) => {
  return axios.request({
    url: "/v1/admin/cmn/product/list",
    method: "get",
    params,
    headers: {
      'AppKey': 'BpLnfgDs'
    }
  });
};

// 整车保用户相关接口
export const zcbUserList = (params) => {
  return axios.request({
    url: "/v1/admin/zcb/user/list",
    method: "get",
    params,
    headers: {
      'AppKey': 'BpLnfgDs'
    }
  });
};

// 获取整车保用户详情
export const zcbUserDetail = (params) => {
  return axios.request({
    url: "/v1/admin/zcb/user/info",
    method: "get",
    params,
    headers: {
      'AppKey': 'BpLnfgDs'
    }
  });
};

// 创建整车保用户
export const createZcbUser = (data) => {
  return axios.request({
    url: "/v1/admin/zcb/user/create",
    method: "post",
    data,
    headers: {
      'AppKey': 'BpLnfgDs'
    }
  });
};

// 更新整车保用户
export const updateZcbUser = (data) => {
  return axios.request({
    url: "/v1/admin/zcb/user/update",
    method: "post",
    data,
    headers: {
      'AppKey': 'BpLnfgDs'
    }
  });
};

export const zcbUpdateUser = (data) => {
  return axios.request({
    url: "/v1/admin/zcb/user/update",
    method: "post",
    data,
    headers: {
      'AppKey': 'BpLnfgDs'
    }
  });
};

export const zcbDisabledUser = (data) => {
  return axios.request({
    url: "/v1/admin/zcb/user/disabled",
    method: "post",
    data,
    headers: {
      'AppKey': 'BpLnfgDs'
    }
  });
};

export const zcbUpdateSigned = (data) => {
  return axios.request({
    url: "/v1/admin/zcb/user/update/signed",
    method: "post",
    data,
    headers: {
      'AppKey': 'BpLnfgDs'
    }
  });
};

export const zcbExportUser = (params) => {
  return axios.request({
    url: "/v1/admin/zcb/user/list",
    method: "get",
    params,
    headers: {
      'AppKey': 'BpLnfgDs'
    }
  });
};

// 整车保用户余额划拨接口
export const zcbBalanceTransfer = (data) => {
  return axios.request({
    url: "/v1/admin/zcb/user/balance/transfer",
    method: "post",
    data,
    headers: {
      'AppKey': 'BpLnfgDs'
    }
  });
};

// 整车保用户人工充值
export const zcbManualDeposit = (data) => {
  return axios.request({
    url: "/v1/admin/zcb/deposit/manual",
    method: "post",
    data,
    headers: {
      'AppKey': 'BpLnfgDs'
    }
  });
};

// 整车保订单相关接口
// 获取整车保订单列表
export const zcbOrderList = (params) => {
  return axios.request({
    url: "/v1/admin/zcb/order/list",
    method: "get",
    params,
    headers: {
      'AppKey': 'BpLnfgDs'
    }
  });
};

// 导出整车保订单Excel
export const zcbExportOrder = (params) => {
  return axios.request({
    url: "/v1/admin/zcb/order/list",
    method: "get",
    params,
    headers: {
      'AppKey': 'BpLnfgDs'
    }
  });
};

// 整车保手动回传保单信息
export const zcbPolicyCallback = (data) => {
  return axios.request({
    url: "/v1/admin/cmn/policy/callback",
    method: "post",
    data,
    headers: {
      'AppKey': 'BpLnfgDs'
    }
  });
};

// 整车保打印申请相关接口
// 获取待处理的打印申请列表
export const getZcbPrintPendingList = (params) => {
  return axios.request({
    url: "/v1/admin/zcb/print/list",
    method: "get",
    params,
    headers: {
      'AppKey': 'BpLnfgDs'
    }
  });
};

// 获取已处理的打印申请列表
export const getZcbPrintProcessedList = (params) => {
  return axios.request({
    url: "/v1/admin/zcb/print/list",
    method: "get",
    params,
    headers: {
      'AppKey': 'BpLnfgDs'
    }
  });
};

// 获取打印申请详情
export const getZcbPrintInfo = (params) => {
  return axios.request({
    url: "/v1/admin/zcb/print/info",
    method: "get",
    params,
    headers: {
      'AppKey': 'BpLnfgDs'
    }
  });
};

// 删除打印申请
export const deleteZcbPrint = (data) => {
  return axios.request({
    url: "/v1/admin/zcb/print/delete",
    method: "post",
    data,
    headers: {
      'AppKey': 'BpLnfgDs'
    }
  });
};

// 处理打印申请
export const checkZcbPrint = (data) => {
  return axios.request({
    url: "/v1/admin/zcb/print/check",
    method: "post",
    data,
    headers: {
      'AppKey': 'BpLnfgDs'
    }
  });
};

// 获取公司信息
export const getCompanyInfo = (params) => {
  return axios.request({
    url: "/v1/admin/cmn/company/info",
    method: "get",
    params,
    headers: {
      'AppKey': 'BpLnfgDs'
    }
  });
};

// 更新公司信息
export const updateCompany = (data) => {
  return axios.request({
    url: "/v1/admin/cmn/company/update",
    method: "post",
    data,
    headers: {
      'AppKey': 'BpLnfgDs'
    }
  });
};

// 创建公司
export const createCompany = (data) => {
  return axios.request({
    url: "/v1/admin/cmn/company/new",
    method: "post",
    data,
    headers: {
      'AppKey': 'BpLnfgDs'
    }
  });
};

// 预约货运险用户相关接口
export const hyxUserList = (params) => {
  return axios.request({
    url: "/v1/admin/hyx/user/list",
    method: "get",
    params,
    headers: {
      'AppKey': 'BpLnfgDs'
    }
  });
};
// 创建用户
export const createUser = (data) => {
  return axios.request({
    url: "/v1/admin/cmn/user/add",
    method: "post",
    data,
    headers: {
      'AppKey': 'BpLnfgDs'
    }
  });
};

// 创建预约货运险用户
export const createHyxUser = (data) => {
  return axios.request({
    url: "/v1/admin/hyx/user/create",
    method: "post",
    data,
    headers: {
      'AppKey': 'BpLnfgDs'
    }
  });
};

// 更新预约货运险用户
export const updateHyxUser = (data) => {
  return axios.request({
    url: "/v1/admin/hyx/user/update",
    method: "post",
    data,
    headers: {
      'AppKey': 'BpLnfgDs'
    }
  });
};

// 预约货运险用户变更渠道
export const changeHyxUserChannel = (data) => {
  return axios.request({
    url: "/v1/admin/hyx/user/update",
    method: "post",
    data,
    headers: {
      'AppKey': 'BpLnfgDs'
    }
  });
};

// 预约货运险用户人工充值
export const manualHyxUserDeposit = (data) => {
  return axios.request({
    url: "/v1/admin/hyx/deposit/manual",
    method: "post",
    data,
    headers: {
      'AppKey': 'BpLnfgDs'
    }
  });
};

// 预约货运险用户余额划拨
export const hyxUserBalanceTransfer = (data) => {
  return axios.request({
    url: "/v1/admin/hyx/user/balance/transfer",
    method: "post",
    data,
    headers: {
      'AppKey': 'BpLnfgDs'
    }
  });
};

// 预约货运险用户添加备注
export const addHyxUserNote = (data) => {
  return axios.request({
    url: "/v1/admin/hyx/user/note",
    method: "post",
    data,
    headers: {
      'AppKey': 'BpLnfgDs'
    }
  });
};

// 预约货运险用户录入协议/保单
export const saveHyxUserPolicy = (data) => {
  return axios.request({
    url: "/v1/admin/hyx/user/policy",
    method: "post",
    data,
    headers: {
      'AppKey': 'BpLnfgDs'
    }
  });
};

// 单票用户相关接口
export const singleUserList = (params) => {
  return axios.request({
    url: "/v1/admin/product/user/list",
    method: "get",
    params,
    headers: {
      'AppKey': 'BpLnfgDs'
    }
  });
};

// 单票用户创建
export const createSingleUser = (data) => {
  return axios.request({
    url: "/v1/admin/product/user/add",
    method: "post",
    data,
    headers: {
      'AppKey': 'BpLnfgDs'
    }
  });
};

// 单票用户信息
export const getSingleUserInfo = (params) => {
  return axios.request({
    url: "/v1/admin/product/user/info",
    method: "get",
    params,
    headers: {
      'AppKey': 'BpLnfgDs'
    }
  });
};

// 单票用户更新
export const updateSingleUser = (data) => {
  return axios.request({
    url: "/v1/admin/product/user/update",
    method: "post",
    data,
    headers: {
      'AppKey': 'BpLnfgDs'
    }
  });
};

// 单票用户锁定/解锁
export const disabledSingleUser = (data) => {
  return axios.request({
    url: "/v1/admin/product/user/disabled",
    method: "post",
    data,
    headers: {
      'AppKey': 'BpLnfgDs'
    }
  });
};

// 单票用户人工充值
export const manualSingleUserDeposit = (data) => {
  return axios.request({
    url: "/v1/admin/product/deposit/manual",
    method: "post",
    data,
    headers: {
      'AppKey': 'BpLnfgDs'
    }
  });
};

// 单票用户保存协议/保单
export const saveSingleUserPolicy = (data) => {
  return axios.request({
    url: "/v1/admin/product/policy/save",
    method: "post",
    data,
    headers: {
      'AppKey': 'BpLnfgDs'
    }
  });
};

// 单票用户变更渠道
export const changeSingleUserChannel = (data) => {
  return axios.request({
    url: "/v1/admin/product/user/update",
    method: "post",
    data,
    headers: {
      'AppKey': 'BpLnfgDs'
    }
  });
};

// 平安干线保用户相关接口
export const paGxbUserList = (params) => {
  return axios.request({
    url: "/v1/admin/gxb/user/list?insurance_type=144",
    method: "get",
    params,
    headers: {
      'AppKey': 'BpLnfgDs'
    }
  });
};

// 创建平安干线保用户
export const createPaGxbUser = (data) => {
  return axios.request({
    url: "/v1/admin/gxb/user/add",
    method: "post",
    data,
    headers: {
      'AppKey': 'BpLnfgDs'
    }
  });
};

// 平安干线保用户更新接口（用于白名单等操作）
export const updatePaGxbUser = (data) => {
  return axios.request({
    url: "/v1/admin/gxb/user/update",
    method: "post",
    data,
    headers: {
      'AppKey': 'BpLnfgDs'
    }
  });
};

// 平安干线保用户锁定/解锁接口
export const disabledPaGxbUser = (data) => {
  return axios.request({
    url: "/v1/admin/gxb/user/disabled",
    method: "post",
    data,
    headers: {
      'AppKey': 'BpLnfgDs'
    }
  });
};

// 平安干线保用户人工充值接口
export const manualPaGxbUserDeposit = (data) => {
  return axios.request({
    url: "/v1/admin/gxb/deposit/manual",
    method: "post",
    data,
    headers: {
      'AppKey': 'BpLnfgDs'
    }
  });
};

// 平安干线保用户录入协议/保单接口
export const savePaGxbUserPolicy = (data) => {
  return axios.request({
    url: "/v1/admin/gxb/policy/save",
    method: "post",
    data,
    headers: {
      'AppKey': 'BpLnfgDs'
    }
  });
};

// 获取平安干线保用户保单列表
export const getPaGxbUserPolicyList = (params) => {
  return axios.request({
    url: "/v1/admin/gxb/policy/list",
    method: "get",
    params,
    headers: {
      'AppKey': 'BpLnfgDs'
    }
  });
};

// 获取平安干线保用户详情
export const getPaGxbUserInfo = (params) => {
  return axios.request({
    url: "/v1/admin/gxb/user/info",
    method: "get",
    params,
    headers: {
      'AppKey': 'BpLnfgDs'
    }
  });
};

// 更新平安干线保用户开票信息
export const updatePaGxbUserInvoice = (data) => {
  return axios.request({
    url: "/v1/admin/gxb/user/update/invoice",
    method: "post",
    data,
    headers: {
      'AppKey': 'BpLnfgDs'
    }
  });
};

// 东海专线保用户相关接口
export const dhGxbUserList = (params) => {
  return axios.request({
    url: "/v1/admin/gxb/user/list?insurance_type=255",
    method: "get",
    params,
    headers: {
      'AppKey': 'BpLnfgDs'
    }
  });
};

// 创建东海专线保用户
export const createDhGxbUser = (data) => {
  return axios.request({
    url: "/v1/admin/gxb/user/add",
    method: "post",
    data,
    headers: {
      'AppKey': 'BpLnfgDs'
    }
  });
};

// 东海专线保用户更新接口（用于白名单等操作）
export const updateDhGxbUser = (data) => {
  return axios.request({
    url: "/v1/admin/gxb/user/update",
    method: "post",
    data,
    headers: {
      'AppKey': 'BpLnfgDs'
    }
  });
};

// 东海专线保用户锁定/解锁接口
export const disabledDhGxbUser = (data) => {
  return axios.request({
    url: "/v1/admin/gxb/user/disabled",
    method: "post",
    data,
    headers: {
      'AppKey': 'BpLnfgDs'
    }
  });
};

// 东海专线保用户人工充值接口
export const manualDhGxbUserDeposit = (data) => {
  return axios.request({
    url: "/v1/admin/gxb/deposit/manual",
    method: "post",
    data,
    headers: {
      'AppKey': 'BpLnfgDs'
    }
  });
};

// 东海专线保用户录入协议/保单接口
export const saveDhGxbUserPolicy = (data) => {
  return axios.request({
    url: "/v1/admin/gxb/policy/save",
    method: "post",
    data,
    headers: {
      'AppKey': 'BpLnfgDs'
    }
  });
};

// 获取东海专线保用户保单列表
export const getDhGxbUserPolicyList = (params) => {
  return axios.request({
    url: "/v1/admin/gxb/policy/list",
    method: "get",
    params,
    headers: {
      'AppKey': 'BpLnfgDs'
    }
  });
};

// 获取东海专线保用户详情
export const getDhGxbUserInfo = (params) => {
  return axios.request({
    url: "/v1/admin/gxb/user/info",
    method: "get",
    params,
    headers: {
      'AppKey': 'BpLnfgDs'
    }
  });
};

// 更新东海专线保用户开票信息
export const updateDhGxbUserInvoice = (data) => {
  return axios.request({
    url: "/v1/admin/gxb/user/update/invoice",
    method: "post",
    data,
    headers: {
      'AppKey': 'BpLnfgDs'
    }
  });
};

// 员工保用户相关接口
export const ygbUserList = (params) => {
  return axios.request({
    url: "/v1/admin/ygb/user/list",
    method: "get",
    params,
    headers: {
      'AppKey': 'BpLnfgDs'
    }
  });
};

// 员工保用户锁定/解锁接口
export const disabledYgbUser = (data) => {
  return axios.request({
    url: "/v1/admin/ygb/user/changedisabled",
    method: "post",
    data: JSON.stringify(data),
    headers: {
      'AppKey': 'BpLnfgDs',
      'Content-Type': 'application/json'
    }
  });
};

// 员工保订单相关接口
export const ygbOrderList = (params) => {
  return axios.request({
    url: "/v1/admin/ygb/order/list",
    method: "get",
    params,
    headers: {
      'AppKey': 'BpLnfgDs'
    }
  });
};

// 导出员工保订单Excel
export const ygbExportOrder = (params) => {
  return axios.request({
    url: "/v1/admin/ygb/order/list/export",
    method: "get",
    params,
    headers: {
      'AppKey': 'BpLnfgDs'
    }
  });
};

// 员工保订单详情
export const ygbOrderInfo = (params) => {
  return axios.request({
    url: "/v1/admin/ygb/order/info",
    method: "get",
    params,
    headers: {
      'AppKey': 'BpLnfgDs'
    }
  });
};

// 员工保订单编辑
export const ygbOrderEdit = (data) => {
  return axios.request({
    url: "/v1/admin/ygb/order/editemployee",
    method: "post",
    data,
    headers: {
      'AppKey': 'BpLnfgDs'
    }
  });
};

// 员工保订单审核修改
export const ygbOrderCheck = (data) => {
  return axios.request({
    url: "/v1/admin/ygb/order/check",
    method: "post",
    data,
    headers: {
      'AppKey': 'BpLnfgDs'
    }
  });
};

// 员工保订单保费打折
export const ygbOrderDiscount = (data) => {
  return axios.request({
    url: "/v1/ygb/admin/order/discount",
    method: "post",
    data,
    headers: {
      'AppKey': 'BpLnfgDs'
    }
  });
};

// 员工保订单保单号录入
export const ygbOrderInputPolicyNo = (data) => {
  return axios.request({
    url: "/v1/admin/ygb/order/inputpolicyno",
    method: "post",
    data,
    headers: {
      'AppKey': 'BpLnfgDs'
    }
  });
};

// 员工保订单删除
export const ygbOrderDelete = (data) => {
  return axios.request({
    url: "/v1/admin/ygb/order/delete",
    method: "post",
    data,
    headers: {
      'AppKey': 'BpLnfgDs'
    }
  });
};

// 员工保订单手动回传
export const ygbOrderPolicyCallback = (data) => {
  return axios.request({
    url: "/v1/admin/cmn/policy/callback",
    method: "post",
    data,
    headers: {
      'AppKey': 'BpLnfgDs'
    }
  });
};

// 员工保订单添加保单
export const ygbOrderSave = (data) => {
  return axios.request({
    url: "/v1/admin/ygb/order/save",
    method: "post",
    data,
    headers: {
      'AppKey': 'BpLnfgDs'
    }
  });
};

// 暂存保单
export const ygbOrderHoldSave = (data) => {
  return axios.request({
    url: "/v1/admin/ygb/staging/order/save",
    method: "post",
    data,
    headers: {
      'AppKey': 'BpLnfgDs'
    }
  });
};
//员工保方案列表
export const ygbProductList = (params) => {
  return axios.request({
    url: "/v1/admin/ygb/product/list",
    method: "get",
    params,
    headers: {
      'AppKey': 'BpLnfgDs'
    }
  });
};

// 员工保关闭/开启加人
export const ygbOrderCloseAdd = (data) => {
  return axios.request({
    url: "/v1/admin/ygb/order/close/add",
    method: "post",
    data,
    headers: {
      'AppKey': 'BpLnfgDs'
    }
  });
};

// 员工保发票状态修改
export const ygbOrderInvoiceReceived = (data) => {
  return axios.request({
    url: "/v1/admin/ygb/order/invoice/received",
    method: "post",
    data,
    headers: {
      'AppKey': 'BpLnfgDs'
    }
  });
};

// 员工保发票信息更新
export const ygbOrderInvoiceUpdate = (data) => {
  return axios.request({
    url: "/v1/admin/ygb/order/invoice/update",
    method: "post",
    data,
    headers: {
      'AppKey': 'BpLnfgDs'
    }
  });
};

// 员工保上传授权书
export const ygbOrderUploadAuthorization = (data) => {
  return axios.request({
    url: "/v1/admin/ygb/order/authorizationUpload",
    method: "post",
    data,
    headers: {
      'AppKey': 'BpLnfgDs'
    }
  });
};

// 员工保授权书审核
export const ygbOrderAuthorizationCheck = (data) => {
  return axios.request({
    url: "/v1/admin/ygb/order/authorizationCheck",
    method: "post",
    data,
    headers: {
      'AppKey': 'BpLnfgDs'
    }
  });
};

// 员工保保单审核
export const ygbOrderPolicyAudit = (data) => {
  return axios.request({
    url: "/v1/admin/ygb/order/policy/audit",
    method: "post",
    data,
    headers: {
      'AppKey': 'BpLnfgDs'
    }
  });
};

// 员工保挂账金额操作
export const ygbOrderBuyerAmount = (data) => {
  return axios.request({
    url: "/v1/admin/ygb/order/buyer/amount",
    method: "post",
    data,
    headers: {
      'AppKey': 'BpLnfgDs'
    }
  });
};

// 获取员工保挂账金额列表
export const ygbOrderAmountList = (params) => {
  return axios.request({
    url: "/v1/admin/ygb/order/amount/list",
    method: "get",
    params,
    headers: {
      'AppKey': 'BpLnfgDs'
    }
  });
};

// 员工保换人操作
export const ygbOrderChangeEmployee = (data) => {
  return axios.request({
    url: "/v1/admin/ygb/order/change/employee",
    method: "post",
    data,
    headers: {
      'AppKey': 'BpLnfgDs'
    }
  });
};

// 员工保退保操作
export const ygbOrderRefund = (data) => {
  return axios.request({
    url: "/v1/admin/ygb/order/refund",
    method: "post",
    data,
    headers: {
      'AppKey': 'BpLnfgDs'
    }
  });
};

// 员工保修改保单
export const ygbOrderModify = (data) => {
  return axios.request({
    url: "/v1/admin/ygb/order/modify",
    method: "post",
    data,
    headers: {
      'AppKey': 'BpLnfgDs'
    }
  });
};

// 员工保变更渠道
export const ygbOrderChangeChannel = (data) => {
  return axios.request({
    url: "/v1/admin/ygb/order/change/channel",
    method: "post",
    data,
    headers: {
      'AppKey': 'BpLnfgDs'
    }
  });
};
export const ygbChangeChannel = (data) => {
  return axios.request({
    url: "/v1/admin/ygb/changechannel",
    method: "post",
    data,
    headers: {
      'AppKey': 'BpLnfgDs'
    }
  });
};

// 员工保添加备注
export const ygbOrderAddRemark = (data) => {
  return axios.request({
    url: "/v1/admin/ygb/order/remark/add",
    method: "post",
    data,
    headers: {
      'AppKey': 'BpLnfgDs'
    }
  });
};

// 员工保修改手机号码
export const ygbOrderChangePhone = (data) => {
  return axios.request({
    url: "/v1/admin/ygb/order/editmobile",
    method: "post",
    data,
    headers: {
      'AppKey': 'BpLnfgDs'
    }
  });
};

// 员工保修改保单号
export const ygbOrderUpdatePolicyNo = (data) => {
  return axios.request({
    url: "/v1/admin/ygb/order/policyno/update",
    method: "post",
    data,
    headers: {
      'AppKey': 'BpLnfgDs'
    }
  });
};

// 商铺保用户相关接口
export const spbUserList = (params) => {
  return axios.request({
    url: "/v1/admin/spb/user/list",
    method: "get",
    params,
    headers: {
      'AppKey': 'BpLnfgDs'
    }
  });
};

// 商铺保用户锁定/解锁接口
export const disabledSpbUser = (data) => {
  return axios.request({
    url: "/v1/admin/spb/user/disabled",
    method: "post",
    data: JSON.stringify(data),
    headers: {
      'AppKey': 'BpLnfgDs',
      'Content-Type': 'application/json'
    }
  });
};

// 大地干线保用户相关接口
export const gxbUserList = (params) => {
  return axios.request({
    url: "/v1/admin/gxb/user/list?insurance_type=2",
    method: "get",
    params,
    headers: {
      'AppKey': 'BpLnfgDs'
    }
  });
};

// 无车承运人用户相关接口
export const wccyrUserList = (params) => {
  return axios.request({
    url: "/v1/admin/gxb/user/list",
    method: "get",
    params,
    headers: {
      'AppKey': 'BpLnfgDs'
    }
  });
};

// 无车承运人用户锁定/解锁接口
export const disabledWccyrUser = (data) => {
  return axios.request({
    url: "/v1/admin/gxb/user/disabled",
    method: "post",
    data: JSON.stringify(data),
    headers: {
      'AppKey': 'BpLnfgDs',
      'Content-Type': 'application/json'
    }
  });
};

// 获取无车承运人用户价格方案列表
export const getWccyrPriceList = (params) => {
  return axios.request({
    url: "/v1/admin/gxb/price/list",
    method: "get",
    params,
    headers: {
      'AppKey': 'BpLnfgDs'
    }
  });
};

// 创建无车承运人用户
export const createWccyrUser = (data) => {
  return axios.request({
    url: "/v1/admin/gxb/user/add",
    method: "post",
    data,
    headers: {
      'AppKey': 'BpLnfgDs'
    }
  });
};

// 公共接口
export const getAppList = (params) => {
  return axios.request({
    url: "/v1/admin/cmn/app/list",
    method: "get",
    params,
    headers: {
      'AppKey': 'BpLnfgDs'
    }
  });
};

export const getChannelList = (params) => {
  return axios.request({
    url: "/v1/admin/cmn/channel/list",
    method: "get",
    params,
    headers: {
      'AppKey': 'BpLnfgDs'
    }
  });
};

// 获取预约货运险用户详情
export const getHyxUserInfo = (params) => {
  return axios.request({
    url: "/v1/admin/hyx/user/info",
    method: "get",
    params,
    headers: {
      'AppKey': 'BpLnfgDs'
    }
  });
};

// 预约货运险用户锁定/解锁
export const disabledHyxUser = (data) => {
  return axios.request({
    url: "/v1/admin/hyx/user/disabled",
    method: "post",
    data,
    headers: {
      'AppKey': 'BpLnfgDs'
    }
  });
};

// 获取保险交易记录
export const getInsuranceTransaction = (params) => {
  return axios.request({
    url: "/v1/admin/cmn/transaction/insurance",
    method: "get",
    params,
    headers: {
      'AppKey': 'BpLnfgDs'
    }
  });
};

// 获取保险公司列表
export const getInsuranceCompanyList = (params) => {
  return axios.request({
    url: "/v1/admin/cmn/insurance/company/list",
    method: "get",
    params,
    headers: {
      'AppKey': 'BpLnfgDs'
    }
  });
};

// 获取预约货运险价格方案列表
export const getHyxPriceList = (params) => {
  return axios.request({
    url: "/v1/admin/hyx/price/list",
    method: "get",
    params,
    headers: {
      'AppKey': 'BpLnfgDs'
    }
  });
};

// 获取预约货运险价格方案详情
export const getHyxPriceDetail = (params) => {
  return axios.request({
    url: "/v1/admin/hyx/price/info",
    method: "get",
    params,
    headers: {
      'AppKey': 'BpLnfgDs'
    }
  });
};

// 保存预约货运险价格方案
export const saveHyxPrice = (data) => {
  return axios.request({
    url: "/v1/admin/hyx/price/save",
    method: "post",
    data,
    headers: {
      'AppKey': 'BpLnfgDs'
    }
  });
};

// 获取预约货运险用户价格方案详情
export const getHyxUserPriceInfo = (params) => {
  return axios.request({
    url: "/v1/admin/hyx/user/info",
    method: "get",
    params,
    headers: {
      'AppKey': 'BpLnfgDs'
    }
  });
};

// 获取用户详情
export const getUserInfo = (params) => {
  return axios.request({
    url: "/v1/admin/cmn/user/info",
    method: "get",
    params,
    headers: {
      'AppKey': 'BpLnfgDs'
    }
  });
};

// 通用会员列表（参考旧项目 /v1/admin/cmn/user/list）
export const cmnUserList = (params) => {
  return axios.request({
    url: "/v1/admin/cmn/user/list",
    method: "get",
    params,
    headers: {
      'AppKey': 'BpLnfgDs'
    }
  });
};

// 通用会员禁用/启用（参考旧项目 /v1/admin/cmn/user/disabled）
export const disabledCmnUser = (data) => {
  return axios.request({
    url: "/v1/admin/cmn/user/disabled",
    method: "post",
    data,
    headers: {
      'AppKey': 'BpLnfgDs'
    }
  });
};

// 通用会员更新（如重置密码）（参考旧项目 /v1/admin/cmn/user/update）
export const updateCmnUser = (data) => {
  return axios.request({
    url: "/v1/admin/cmn/user/update",
    method: "post",
    data,
    headers: {
      'AppKey': 'BpLnfgDs'
    }
  });
};

// 获取管理员信息
export const getAdminInfo = (params) => {
  return axios.request({
    url: "/v1/admin/cmn/admin/info",
    method: "get",
    params,
    headers: {
      'AppKey': 'BpLnfgDs'
    }
  });
};

// 获取用户收件地址列表
export const getUserAddressList = (params) => {
  return axios.request({
    url: "/v1/admin/cmn/useraddress/list",
    method: "get",
    params,
    headers: {
      'AppKey': 'BpLnfgDs'
    }
  });
};

// 添加用户收件地址
export const addUserAddress = (data) => {
  return axios.request({
    url: "/v1/admin/cmn/useraddress/add",
    method: "post",
    data,
    headers: {
      'AppKey': 'BpLnfgDs'
    }
  });
};

// 更新用户收件地址
export const updateUserAddress = (data) => {
  return axios.request({
    url: "/v1/admin/cmn/useraddress/update",
    method: "post",
    data,
    headers: {
      'AppKey': 'BpLnfgDs'
    }
  });
};

// 删除用户收件地址（与旧项目一致使用 GET）
export const deleteUserAddress = (params) => {
  return axios.request({
    url: "/v1/admin/cmn/useraddress/delete",
    method: "get",
    params,
    headers: {
      'AppKey': 'BpLnfgDs'
    }
  });
};

// 获取无车承运人用户价格方案详情
export const getWccyrPriceInfo = (params) => {
  return axios.request({
    url: "/v1/admin/gxb/price/info",
    method: "get",
    params,
    headers: {
      'AppKey': 'BpLnfgDs'
    }
  });
};

// 获取员工保年龄限制列表
export const ygbOrderAgeList = (params) => {
  return axios.request({
    url: "/v1/admin/ygb/order/age/list",
    method: "get",
    params,
    headers: {
      'AppKey': 'BpLnfgDs'
    }
  });
};

// 批量校验身份证号码
export const checkBatchIdcard = (data) => {
  return axios.request({
    url: "/v1/admin/cmn/check/batch/idcard",
    method: "post",
    data,
    headers: {
      'AppKey': 'BpLnfgDs'
    }
  });
};

// 计算员工保退保保费
export const ygbCalculateRefundPremium = (params) => {
  return axios.request({
    url: "/v1/admin/ygb/order/add/per/price",
    method: "get",
    params,
    headers: {
      'AppKey': 'BpLnfgDs'
    }
  });
};

// 员工保退保提交
export const ygbReturnInsurance = (data) => {
  return axios.request({
    url: "/v1/admin/ygb/returninsurance",
    method: "post",
    data,
    headers: {
      'AppKey': 'BpLnfgDs'
    }
  });
};

// 获取员工保订单员工列表
export const ygbOrderEmployeeList = (params) => {
  return axios.request({
    url: "/v1/admin/ygb/order/employeelist",
    method: "get",
    params,
    headers: {
      'AppKey': 'BpLnfgDs'
    }
  });
};

// 员工保订单编辑员工信息
export const ygbOrderEditEmployee = (data) => {
  return axios.request({
    url: "/v1/admin/ygb/order/editemployee",
    method: "post",
    data,
    headers: {
      'AppKey': 'BpLnfgDs'
    }
  });
};

// 员工保订单添加员工
export const ygbOrderAddEmployee = (data) => {
  return axios.request({
    url: "/v1/admin/ygb/order/addemployee",
    method: "post",
    data,
    headers: {
      'AppKey': 'BpLnfgDs'
    }
  });
};

// 员工保订单计算加保单价
export const ygbOrderAddPerPrice = (params) => {
  return axios.request({
    url: "/v1/admin/ygb/order/add/per/price",
    method: "get",
    params,
    headers: {
      'AppKey': 'BpLnfgDs'
    }
  });
};

// 员工保订单暂存员工
export const ygbOrderAddEmployeeTemp = (data) => {
  return axios.request({
    url: "/v1/admin/ygb/addemployeetemp/save",
    method: "post",
    data,
    headers: {
      'AppKey': 'BpLnfgDs'
    }
  });
};

// 添加子账户
export const addSubAccount = (data) => {
  return axios.request({
    url: "/v1/admin/cmn/subaccout/add",
    method: "post",
    data,
    headers: {
      'AppKey': 'BpLnfgDs'
    }
  });
};
